import { cn } from "@/modules/lib/utils"
import { getVimeoThumbnailUrl } from "@/modules/utils/mediaUtils"
import { Loader2, VideoIcon } from "lucide-react"
import { useEffect, useState } from "react"

export function VimeoThumbnail({ url, className }: { url: string; className?: string }) {
  const [thumbnailUrl, setThumbnailUrl] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false

    getVimeoThumbnailUrl(url)
      .then((thumbnail) => {
        if (!cancelled && thumbnail) {
          setThumbnailUrl(thumbnail)
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false)
        }
      })

    return () => {
      cancelled = true
    }
  }, [url])

  if (loading || !thumbnailUrl) {
    return (
      <div className={cn("flex items-center justify-center bg-neutral-300", className)}>
        {/* Optionnel: spinner de chargement */}
        <Loader2 className="size-4 animate-spin text-textDefault-placeholder" />
      </div>
    )
  }

  return (
    <>
      <div
        className={cn("h-full w-full bg-neutral-900/32 bg-cover bg-center bg-no-repeat bg-blend-multiply", className)}
        style={{
          backgroundImage: `url(${thumbnailUrl})`,
        }}
      />
      <VideoIcon className="size-2xl center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-neutral-100" />
    </>
  )
}
